// let baseurl='https://apidev.iserveu.online/isu/LOS/';
// let baseurl='https://apidev.iserveu.online/ktuat/isu/camunda/';//'https://txnflow.txninfra.com/isu/camunda/';
let baseurl = `https://api-prod.txninfra.com/kotak/kotak/camunda/los/`;
export const ApiUrl = {
  // GetFeature:`https://services.iserveu.online/camunda/fetchFeature`,
  GetFeature: `https://api-prod.txninfra.com/kotak/kotak/camunda/feature/fetchFeature`,
  StartProcess: `${baseurl}startProcessInstance`,
  FormSchema: `${baseurl}getFormSchema/`,
  CompleteTask: `${baseurl}completeTask/`,
  ElasticSearch: `${baseurl}elasticSearch/companies_master/_search`,
};
